import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

/**
 * Password input with an inline show/hide (eyeball) toggle pinned to the right edge.
 * Pass `testid` for the input; the toggle button gets `${testid}-toggle`.
 */
export const PasswordInput = ({ className = "", testid, ...props }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <input
        {...props}
        type={show ? "text" : "password"}
        className={`${className} pr-9`}
        data-testid={testid}
      />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        tabIndex={-1}
        aria-label={show ? "Hide password" : "Show password"}
        className="absolute inset-y-0 right-0 flex items-center px-2 text-[#555] hover:text-[#7B0099] focus:outline-none"
        data-testid={testid ? `${testid}-toggle` : "password-toggle"}
      >
        {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
};

export default PasswordInput;
